import $http from "../../axios";
import { Notification } from 'element-ui';
import {getApiDomain} from "../../util/domains";

/**
 * Obtener tipo de comprobante.
 */
export async function fetchVoucherType({commit, state}) {
    await $http.get('/api/tipos-de-comprobantes', { params : state.params_voucher_type})
        .then((response) => {
            commit('setVouchersTypes', response.data.data)
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });
        })
}
/**
 * Obtener sedes.
 */
export async function fetchBranchOffices ({ commit, state }) {
    await $http.get('/api/sedes')
        .then((response) => {
            commit('setBranchOffices', response.data)
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });
        })
}
/**
 * Obtener Contactos
 */
export async function fetchContacts({commit,state}, requestParameters = {params: state.params_query}) {
    await $http.get('/api/terceros', requestParameters)
        .then((response) => {
            commit('setContacts', response.data.data.data)
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
        })
}
/**
 * Obtener la información del reporte
 */
export async function fetchReportSalesReferrals({commit, state, dispatch}) {
    commit('setLoading', true);
    await $http.get('/api/get-sales-referrals', {params:state.params})
        .then((response) => {
            commit('setReportData', response.data.data);
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
        }).finally(() => {
            commit('setLoading', false);
        });
}
/**
 * Obtener los productos de un documento
 */
export async function fetchDocumentProducts({commit, state}, id) {
    await $http.get('/api/get-products-documents-referrals/' + id)
        .then((response) => {
            commit('setProductDetailsDocument', response.data.data);
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
        })
}

export async function fetchDocumentProductsProductID({commit, state}, id) {
    await $http.get('/api/get-products-documents-referrals/' + id, {params: {product_id: state.product_id_details_document_query}})
        .then((response) => {
            commit('setProductDetailsDocument', response.data.data);
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
        })
}
/**
 * Obtener la información de la segunda tabla
 */
export async function fetchDocumentReferrals({commit, state}, params) {
    commit('setLoading', true);
    await $http.get('/api/get-sales-referrals', {
        params: { document_id: params.document_id, product_id: params.product_id }
        })
        .then((response) => {
            commit('setDocumentReferrals', response.data.data);
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
        }).finally(() => {
            commit('setLoading', false);
            //commit('setProductIDDetailsDocumentQuery', null);
        });
}
/**
 * Obtener la infomación de la descarga del pdf
 */
export async function downloadDocument({state}, documentDownload) {

    let name = documentDownload.voucher_type + ' No. ' + documentDownload.num_doc + '.pdf'

    let url = '/api/documentos/descargar-pdf/' + documentDownload.document_id

    await $http({
        url: url,
        method: 'GET',
        responseType: 'blob',
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();
    }).catch((error) => {
        Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 3000,
            customClass: 'notification-box',
        });

    })
}

/* PDF V2 */
export async function createPDf({ commit, state }, id) {
    await $http
        .get(`/api/pdf/${id}`)
        .then(response => {
            commit("setNamePdf", response.data.data.pdf);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: "Error al traer el pdf del documento.",
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}

/* PDF V2 */
export async function fetchNameColumnStatus({ commit, state }) {
    await $http
        .get(`/api/get-parameter-type-business`)
        .then(response => {
            commit("setColumnStatus", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: "Error al traer el pdf del documento.",
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}

export async function fetchTemplates({commit, state}) {
    await $http.get('/api/modelos', { params : state.paramsTemplates})
        .then((response) => {
            commit('setTemplates', response.data.data.data)
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });
        })
}



// WEBPACK FOOTER //
// ./src/modules/report-sales-referrals/actions.js